import { DataServiceOperator } from './data-service-operator.interface';

export class DataServiceDivide implements DataServiceOperator {
	public calculate(valueA: number | string, valueB: number | string, defaultValue: number): number {
		if (!isNaN(Number(valueA)) && !isNaN(Number(valueB)) && Number(valueB) !== 0) {
			return Number(valueA) / Number(valueB);
		}
		return defaultValue;
	}
}
